import { render, staticRenderFns } from "./BusinessSignUp.vue?vue&type=template&id=79f21aa3"
import script from "./BusinessSignUp.vue?vue&type=script&lang=js"
export * from "./BusinessSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports